import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-design-principle',
  templateUrl: './design-principle.component.html',
  styleUrls: ['./design-principle.component.scss']
})
export class DesignPrincipleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
